/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestKilnStakingContract extends Contract<ITestKilnStakingContract> {
  getELFeeRecipient: Call<(_publicKey: BytesLike) => string, ITestKilnStakingContract>
  'getELFeeRecipient(bytes)': Call<(_publicKey: BytesLike) => string, ITestKilnStakingContract>
  getGlobalFee: Call<() => BigNumber, ITestKilnStakingContract>
  'getGlobalFee()': Call<() => BigNumber, ITestKilnStakingContract>
  getOperatorFee: Call<() => BigNumber, ITestKilnStakingContract>
  'getOperatorFee()': Call<() => BigNumber, ITestKilnStakingContract>
}

let ITestKilnStakingContractBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestKilnStakingContractBytecode = '0x';
}

// prettier-ignore
export const ITestKilnStakingContract = contract<ITestKilnStakingContract>(ITestKilnStakingContractBytecode)`
  event Deposit(address indexed caller, address indexed withdrawer, bytes publicKey, bytes signature)
  function getELFeeRecipient(bytes _publicKey) view returns (address elFeeRecipient_)
  function getGlobalFee() view returns (uint256 gloablFee_)
  function getOperatorFee() view returns (uint256 operatorFee_)
`;